function isDOMKeyframes(keyframes) {
    return typeof keyframes === "object" && !Array.isArray(keyframes);
}

export { isDOMKeyframes };
//# sourceMappingURL=is-dom-keyframes.mjs.map
